import React, {useEffect, useState} from "react";
import "./orderMC.style.scss";
import {Button, Card, Dropdown, Input, Radio, Menu, Typography} from "antd";
import {get, post, responseValidator, SITEURL} from "../../../../../api";
import Loading from "../../../../../loading/loading.index";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import {toast} from "react-toastify";
import {ToIranCurrency} from "../../../../../util/string";

export default function OrderS1MC() {
    const [payment, setPayment] = useState(null);
    const [allPayment, setALlPayment] = useState([]);
    const [allCards, setAllCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [allNetworks, setAllNetworks] = useState([]);
    const [networkSelected, setNetworkSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [orderDetail, setOrderDetail] = useState(null);
    const [isMemo, setIsMemo] = useState(false);
    const {Text} = Typography;
    const [wallet, setWallet] = useState(null);
    const [memo, setMemo] = useState(null);
    const [walletBool, setWalletBool] = useState(undefined);
    const [memoBool, setMemoBool] = useState(undefined);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isAllDisable, setIsAllDisable] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState(30);
    const [paymentURL, setPaymentURL] = useState(null);
    const [voher, setVocher] = useState();
    const [activatior, setActivator] = useState();
    const [timeRemaining2, setTimeRemaining2] = useState(300);
    const [timeOut, setTimeOut] = useState(false);


    function s_to_mmss(time = 0) {
        const second = time % 60;
        const min = Math.floor(time / 60);
        return (
            (min < 10 ? "0" + min : min) +
            ":" +
            (second < 10 ? "0" + second : second)
        );
    }

    function counter(value) {
        setTimeRemaining(value);
        if (value > 0) {
            setTimeRemaining(value);
            setTimeout(() => {
                counter(value - 1);
            }, 1000);
        } else {
            setTimeOut(true);
        }
    }

    function counter2(value) {
        setTimeRemaining2(value);
        if (value > 0) {
            setTimeRemaining2(value);
            setTimeout(() => {
                counter2(value - 1);
            }, 1000);
        } else {
            setTimeOut(true);
        }
    }

    useEffect(() => {
        if (isAllDisable) counter(30);
        else counter2(300)
    }, [isAllDisable]);

    function getNetworks(order) {
        return new Promise(resolve => {
            get(`/Market/Crypto/${order}/Networks`).then(res => {
                resolve(true);
                if (responseValidator(res.status)) {
                    //   console.log((res.data.data.networks)[0])
                    setNetworkSelected(
                        res.data.data.networks.find(
                            item => order==='USDT'? item.network==='TRX':item.isDefault === true
                        )
                    );
                    setAllNetworks(res.data.data.networks);
                    //     setNetworkSelected((res.data.data.networks)[0])
                } else toast.error(res.data.message);
            });
        });
    }

    useEffect(() => {
        if (networkSelected) {
            setMemo("");
            setMemoBool(undefined);
            if (networkSelected.memoRegex !== "") {
                setIsMemo(true);
            } else {
                setIsMemo(false);
            }
        }
        setWallet(undefined);
    }, [networkSelected]);

    function getOrder() {
        setPageLoading(true);
        return new Promise(resolve => {
            get(`/Order/` + localStorage.getItem("order") + `/Details`).then(
                res => {
                    setPageLoading(false);
                    if (responseValidator(res.status)) {
                        setOrderDetail(res.data.data);
                        resolve(res.data.data.withdrawTransaction.market);
                    } else {
                        window.location.replace("/userpanel/order/");
                        toast.error(res.data.message);
                    }
                }
            );
        });
    }

    async function getDetails() {
        const order = await getOrder();
        const networks = await getNetworks(order.symbol);
        console.log(order);
        setLoading(false);
    }

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (networkSelected) {
            if (wallet === "" || wallet === undefined) setWalletBool(undefined);
            else {
                const regex = new RegExp(networkSelected.addressRegex);
                setWalletBool(regex.test(wallet));
            }
        }
    }, [wallet]);

    useEffect(() => {
        if (networkSelected) {
            if (memo === "") setMemoBool(undefined);
            else {
                console.log(networkSelected.memoRegex);
                const regex = new RegExp(networkSelected.memoRegex);
                console.log(regex);
                console.log(regex.test(memo));
                setMemoBool(regex.test(memo));
            }
        }
    }, [memo]);

    function submitHandler() {
        if (!isAllDisable) {
            setSubmitLoading(true);
            let body = {
                trackingCode: localStorage.getItem("order"),
                voucherCode: voher,
                voucherActivate: activatior,
                destinationWallet: wallet,
                destinationNetwork: networkSelected.network
            };
            if (isMemo) body.destinationMemoTag = memo;
            post("/Order/Deposit/Money", body).then(res => {
                setSubmitLoading(false);
                if (responseValidator(res.status)) {
                    window.location.replace(
                        `/userpanel/order/verify/${orderDetail.trackingCode}?amount=4000000&refnum=rWz2B7qO&state=SUCCESSFUL&payment`
                    );
                } else toast.error(res.data.message);
            });
        } else {
            console.log(paymentURL);
            window.location.replace(paymentURL);
        }
    }

    if (!networkSelected || pageLoading) return <Loading/>;
    else
        return (
            <div className="order-first-step-irt-c-page">
                 <h3>{isAllDisable ? 'فاکتور نهایی' : 'پیش فاکتور'}</h3>
                 <p style={{margin:'6px'}}>طریقه ایجادحساب جهت درج در وب سایت تم ایکس: </p>
                <p style={{margin:'6px'}} >از قسمت منو حساب خود بروی withdraw (برداشت)  کلیک‌نموده و در صفحه بعد بروی E-voucher کلیک نمائید. تعداد دلار مد نظر خود را ثبت و ووچر صادر شده را در سایت درج نمائید.</p>
                <p style={{margin:'6px 6px 24px'}} >در صورتی که مقدار وچری که قصد فروش/تبدیل دارید را نمی‌دانید عدد 1 را در قسمت تعداد دلار وارد نمایید. </p>

                <div className="order-first-step-irt-c-page-content">
                    {loading && <Loading/>}
                    <Card title="ارز مبدا">
                        <div className="item">
                            <p>نام :‌ </p>
                            <h5>
                                {
                                    orderDetail.depositTransaction.market
                                        .description
                                }
                            </h5>
                            <img alt='crypto'
                                 style={{width: '35px', height: '35px', borderRadius: '100%', marginRight: '10px'}}
                                 src={
                                     SITEURL + orderDetail.depositTransaction.market
                                         .icon
                                 }/>
                        </div>
                        <div className="item">
                            <p>مقدار : </p>
                            <h5>
                                {orderDetail.depositTransaction.amount} واحد
                            </h5>
                        </div>

                        <div className="item">
                            <p>کارمزد تبدیل: </p>
                            <h5>
                                {ToIranCurrency(orderDetail.depositTransaction.rateCommssion)} واحد
                            </h5>
                        </div>
                        <div className="my-inputs item">
                            <p style={{marginLeft: "12px", minWidth: "90px"}}>
                                کد ووچر :{" "}
                            </p>
                            <Input
                                style={{maxWidth: "300px"}}
                                disabled={isAllDisable}
                                value={voher}
                                onChange={e => setVocher(e.target.value)}
                                placeholder="ووچر"
                            />
                        </div>
                        <div className="my-inputs item">
                            <p style={{marginLeft: "12px", minWidth: "90px"}}>
                                کد فعال ساز :{" "}
                            </p>
                            <Input
                                style={{maxWidth: "300px"}}
                                disabled={isAllDisable}
                                value={activatior}
                                onChange={e => setActivator(e.target.value)}
                                placeholder="فعال ساز"
                            />
                        </div>
                    </Card>
                    <Card title="ارز مقصد">
                        <div className="item">
                            <p>نام :‌ </p>
                            <h5>
                                {
                                    orderDetail.withdrawTransaction.market
                                        .description
                                }
                            </h5>
                            <img alt='crypto'
                                 style={{width: '35px', height: '35px', borderRadius: '100%', marginRight: '10px'}}
                                 src={
                                     SITEURL + orderDetail.withdrawTransaction.market
                                         .icon
                                 }/>
                        </div>
                        <div className="item">
                            <p>مقدار دریافتی : </p>
                            <h5>
                                {orderDetail.withdrawTransaction.amount} واحد
                            </h5>
                        </div>
                        <div className="card network">
                            <p style={{marginLeft: 0}}>
                                شبکه مورد نظر را انتخاب نمایید :{" "}
                            </p>
                            {allNetworks.length !== 0 && (
                                <Dropdown
                                    disabled={isAllDisable}
                                    overlay={
                                        <Menu>
                                            {allNetworks.map(item => (
                                                <Menu.Item
                                                    onClick={() =>
                                                        setNetworkSelected(item)
                                                    }
                                                    key={item.name}
                                                >
                                                    <div className="one-card-drop-down-selected network">
                                                        <h4>{item.name}</h4>
                                                    </div>
                                                </Menu.Item>
                                            ))}
                                        </Menu>
                                    }
                                    trigger={["click"]}
                                >
                                    <div className="one-card-drop-down-selected payment">
                                        <h4>{networkSelected.name}</h4>
                                        <DownOutlined/>
                                    </div>
                                </Dropdown>
                            )}
                        </div>
                        <div className="network-detail">
                            <Text type="warning">
                                فی شبکه :{" "}
                                {networkSelected.withdrawFee +
                                " " +
                                orderDetail.withdrawTransaction.market
                                    .symbol}
                            </Text>
                          ;
                            <Text type="secondary">
                                {" "}
                                مقدار دریافتی :{" "}
                                {parseFloat(
                                    orderDetail.withdrawTransaction.amount
                                ) -
                                parseFloat(networkSelected.withdrawFee) +
                                " " +
                                orderDetail.withdrawTransaction.market
                                    .symbol}
                            </Text>
                        </div>
                    </Card>
                </div>
                <Card className="my-input-card">
                    <div className="right">
                        <div className="my-inputs">
                            <p>ادرس کیف پول مقصد: </p>
                            <Input
                                disabled={isAllDisable}
                                value={wallet}
                                onChange={e => setWallet(e.target.value)}
                                placeholder=""
                            />
                            {walletBool !== undefined ? (
                                walletBool === false ? (
                                    <Text className="error-text" type="danger">
                                        نا معتبر
                                    </Text>
                                ) : (
                                    <Text className="error-text" type="success">
                                        معتبر
                                    </Text>
                                )
                            ) : (
                                <div className="error-text"/>
                            )}
                        </div>
                        {isMemo && (
                            <div className="my-inputs">
                                <p>Memmo : </p>
                                <Input
                                    value={memo}
                                    onChange={e => setMemo(e.target.value)}
                                    disabled={isAllDisable}
                                    placeholder="memo or tag"
                                />
                                {memoBool !== undefined ? (
                                    memoBool === false ? (
                                        <Text
                                            className="error-text"
                                            type="danger"
                                        >
                                            نا معتبر
                                        </Text>
                                    ) : (
                                        <Text
                                            className="error-text"
                                            type="success"
                                        >
                                            معتبر
                                        </Text>
                                    )
                                ) : (
                                    <div className="error-text"/>
                                )}
                            </div>
                        )}
                    </div>

                    <div className="my-btn">
                          <Button
                            style={{left:'150px'}}
                            onClick={()=>window.location.href='/userpanel/order'}
                            type={"default"}
                        >
                            لغو
                        </Button>
                        <Button
                            disabled={
                                (!walletBool ||
                                    (isMemo && !memoBool) ||
                                    !activatior ||
                                    !voher) &&
                                !isAllDisable &&
                                !timeOut
                            }
                            onClick={submitHandler}
                            loading={submitLoading}
                            type={"primary"}
                        >
                            {isAllDisable ? "انتقال به درگاه پرداخت" : "ادامه"}
                        </Button>
                        {isAllDisable && !timeOut? (
                            <Text type="warning counter">
                                {" "}
                                زمان باقی مانده : {s_to_mmss(
                                timeRemaining
                            )}{" "}
                                دقیقه
                            </Text>
                        ) :  isAllDisable &&!timeOut?
                            <Text type="warning counter">
                            {" "}
                            زمان باقی مانده : {s_to_mmss(
                            timeRemaining2
                        )}{" "}
                            دقیقه
                        </Text>
                            :
                            (
                                <Text type="danger counter">
                                    سفارش شما منقضی شده است
                                </Text>
                            )
                            }
                    </div>
                </Card>
            </div>
        );
}
